import React from 'react'
import { Card, Typography, Box, Button } from '@mui/material'
import { format, parse } from 'date-fns'
import { es } from 'date-fns/locale'
import { AnuncioDTO } from '../types/anuncios.types'
import { AnunciosProps } from './TablaAnuncios'
import TablaServerPagination from '../../../components/Common/utils/paginator/serverPaginator'
import NoSearch from '../../../components/Common/NoSearch'
import NoResults from '../../../components/Common/NoResults'

const CardsAnuncios: React.FC<AnunciosProps> = ({
  loading,
  anuncios,
  anunciantes,
  tiposAnucio,
  paginator,
  searching,
  handleUpdate,
  handleDelete
}) => {
  return (
    <>
      {anuncios?.length <= 0 ? (
        !searching ? (
          <NoSearch items="anuncios" />
        ) : (
          <NoResults />
        )
      ) : (
        anuncios.map((a: AnuncioDTO, index: number) => {
          const fechaDesde = a.fechaDesde
            ? format(parse(a.fechaDesde, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy', { locale: es })
            : null

          const fechaHasta = a.fechaHasta
            ? format(parse(a.fechaHasta, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy', { locale: es })
            : null
          return (
            <Card key={index} variant="outlined" sx={{ margin: '20px', padding: '10px' }}>
              <Typography style={{ marginBottom: '8px', fontWeight: 'bold' }} variant="h5">
                {`${a.nombre} (${a.idAnuncio})`}
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginTop: '4px',
                  gap: '4px'
                }}
              >
                <Typography variant="body1">
                  <strong>Anunciante:</strong>{' '}
                  {anunciantes.find((item) => item.idAnunciante === a.idAnunciante)?.nombre}
                </Typography>
                <Typography variant="body1">
                  <strong>Tipo de anuncio:</strong> {tiposAnucio.find((tipo) => tipo.id === a.idAnuncioTipo)?.nombre}
                </Typography>
                {fechaDesde && (
                  <Typography variant="body1">
                    <strong>Fecha Desde:</strong> {fechaDesde}
                  </Typography>
                )}
                {fechaHasta && (
                  <Typography variant="body1">
                    <strong>Fecha Hasta:</strong> {fechaHasta}
                  </Typography>
                )}
              </Box>
              <Box sx={{ display: 'flex', mt: '1rem', gap: '1rem', justifyContent: 'space-between' }}>
                <Button
                  disabled={loading}
                  sx={{ width: '100%' }}
                  variant="contained"
                  color="error"
                  onClick={() => handleDelete(a.idAnuncio)}
                >
                  Borrar
                </Button>
                <Button
                  disabled={loading}
                  sx={{ width: '100%' }}
                  variant="contained"
                  color="success"
                  onClick={() => handleUpdate(a.idAnuncio)}
                >
                  Editar
                </Button>
              </Box>
            </Card>
          )
        })
      )}
      <TablaServerPagination label={'Tamaño página'} paginator={paginator} component={'td'} />
    </>
  )
}

export default CardsAnuncios
